module.exports = __webpack_public_path__ + "static/media/timer-icon.2d4f8165.svg";